import { useSelector } from 'react-redux';

import { DemoOrders } from '../constants/features';
import Global from '../store/global-selectors';

/**
 * Hook to check if the DemoOrders feature is enabled for the current seller
 * @returns {boolean} True if DemoOrders feature is enabled via Labs page
 */
export const useHasDemoOrdersFeature = () => {
  const sellerFeatures = useSelector(Global.selectSellerSellerFeatures);
  return sellerFeatures?.includes(DemoOrders) ?? false;
};
